<template>
    <div>
        <p class=" text-center black--text py-0 my-0">
            Copyright © 2022 - {{ new Date().getFullYear() }} Todos los Derechos Reservados| Desarrollado por 
                    <a href="http://kwsoluciones.com" target="_blank">kwsoluciones.com</a>   +58 412 0694916 <br/>
        </p>      
    </div>
</template>

<script>
    export default {
        name: "FooterComp",        
    };
</script>

<style scoped>
 </style>